import { useNewStrategyContext } from './NewStrategyContext';

import { ProfitLoss } from '../ProfitLoss';
import { Icon } from '../UI';
import { Title } from './Title';

import { SvgProps } from '../UI/Icon/Icon';
import { IStrategyAsset, TTickerCurrency } from '../../types/model';
import { Currency } from '../../types/common';

import { computePercentage, getSymbol } from '../../helpers/functions';
import { CustomNumber } from '../CustomNumber/CustomNumber';

export const CreateAsset = ({
  asset: {
    id: assetId,
    entryPrice,
    asset: { history, name: description, logo, type },
    name,
    unit,
  },
  currency,
  isNewStrategy,
  svgName,
  totalValueStrategy,
  handleAsset,
}: {
  asset: IStrategyAsset;
  currency: Currency['code'];
  isNewStrategy: boolean;
  svgName: SvgProps['svgName'];
  totalValueStrategy: number;
  handleAsset(): void;
}) => {
  const {
    newStrategy: { assets },
    totalValueNewStrategy,
  } = useNewStrategyContext();

  const isSelectedAsset =
    !isNewStrategy && assets.some(({ id }) => id === assetId);

  const symbol = getSymbol(currency);
  const lastPrice =
    history[0]?.[currency.toLocaleLowerCase() as TTickerCurrency];

  const assetValue = unit * lastPrice;

  const invValue = isNewStrategy ? totalValueNewStrategy : totalValueStrategy!;

  const assetPercentage = computePercentage(entryPrice, lastPrice, 100);

  const allocation = computePercentage(invValue, assetValue);

  return (
    <div
      className={`
        grid
        grid-cols-6
        items-center
        pl-5
        min-h-16
        border-b
        border-grey-30
        dark:border-grey-70
        bg-grey-10
        dark:bg-grey-80
        dark:text-white
      `}
    >
      {/* name */}
      <Title
        assetType={type}
        className="col-span-2 ml-1"
        description={description}
        logo={logo}
        title={name}
      />

      {/* quantity */}
      <CustomNumber
        className="bg-grey-10 dark:bg-grey-80"
        allowNegative={false}
        value={unit}
      />

      {/* last price */}
      <CustomNumber
        className="bg-grey-10 dark:bg-grey-80"
        suffix={symbol}
        value={lastPrice}
      />

      {/* tot value */}
      <ProfitLoss
        percentage={isNewStrategy ? null : assetPercentage}
        symbol={symbol!}
        value={assetValue}
      />

      {/* percentage invested */}
      <div className="flex items-center justify-between">
        <CustomNumber
          allowNegative={false}
          className="w-3/4 bg-grey-10 dark:bg-grey-80"
          decimalScale={2}
          suffix={'%'}
          value={allocation}
        />

        <Icon
          className={`
            mr-5
            ${isSelectedAsset ? 'cursor-not-allowed' : 'cursor-pointer'}
          `}
          onClick={handleAsset}
          svgName={svgName}
          color={isSelectedAsset ? 'grey-30' : undefined}
        />
      </div>
    </div>
  );
};
